import { render, staticRenderFns } from "./Document-form.vue?vue&type=template&id=2ea87058&scoped=true"
import script from "./Document-form.vue?vue&type=script&lang=js"
export * from "./Document-form.vue?vue&type=script&lang=js"
import style0 from "./Document-form.vue?vue&type=style&index=0&id=2ea87058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea87058",
  null
  
)

export default component.exports